import { analysis, analysisNames, IAnalysisResult } from "./analysisHelper";

const union = (oldLayerName: string, newLayerName: string, boundary: Array<number>| null = null) => {
    if (!oldLayerName) {
        window.pWarn('参数 oldLayerName 不能为空！');
        return;
    }

    let analysisName = analysisNames.union;

    if (!newLayerName) {
        newLayerName = oldLayerName + "_" + analysisName;
    }

    analysis(oldLayerName, newLayerName, analysisName, boundary, (result) => {
        console.log("analysis result " + JSON.stringify(result));
        //window.VGIS.vMap.addGeoJson(result.GeoJson, newLayerName);
    });

}

export default union;